<template>
  <div id="search-form">
    <form @submit.prevent class="container d-flex flex-column">
      <div class="row mb-3">
        <fieldset class="search col-md-3">
          <legend>{{$t('form.search.legend')}}</legend>
          <ncs-search-type/>
        </fieldset>
        <fieldset class="result col-md-9">
          <legend>{{$t('form.result.legend')}}</legend>
          <div class="row">
            <div class="col-md-3">
              <ncs-result-type/>
            </div>
            <div class="col-md-6">
              <ncs-order-selector/>
            </div>
            <div class="col-md-3">
              <ncs-page-size-selector/>
            </div>
            <div class="col-md-6 offset-md-3">
              <ncs-matching-expressions-group-selector/>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="row mb-3">
        <fieldset class="sensibility col-md-3">
          <legend>{{$t('form.sensibility.legend')}}</legend>
          <ncs-global-option-checkbox name="ncs_accent" :value="true"/>
          <ncs-global-option-checkbox name="case" :value="true"/>
        </fieldset>
        <fieldset class="filters col-md-9">
          <legend>{{$t('form.filters.legend')}}</legend>
          <div class="row">
            <div class="col-md-4">
              <ncs-multi-select field="ncs_documents.periodico"/>
            </div>
            <div class="col-md-4">
              <ncs-multi-select field="ncs_documents.titulo_columna"/>
            </div>
            <div class="col-md-4">
              <ncs-multi-select field="ncs_documents.lugar_publicacion"/>
            </div>
            <div class="col-md-4">
              <ncs-multi-select field="ncs_documents.autor"/>
            </div>
            <div class="col-md-4">
              <ncs-number-select-filter type="number" name="ncs_documents.ano_publicacion_from"
                                        field="ncs_documents.ano_publicacion"
                                        :min="1939" :max="2023" operator="gteq"/>
            </div>
            <div class="col-md-4">
              <ncs-number-select-filter type="number" name="ncs_documents.ano_publicacion_to"
                                        field="ncs_documents.ano_publicacion"
                                        :min="1939" :max="2023" operator="lteq" :reverse="true"/>
            </div>
          </div>
        </fieldset>
        <fieldset class="extra_filters col-md-9 offset-md-3">
          <legend>
            <a href="#" @click="extra_filters = !extra_filters">
              <i v-if="extra_filters" class="fa fa-minus fa-fw"></i>
              <i v-else class="fa fa-plus fa-fw"></i>
              {{$t('form.extra_filters.legend')}}
            </a>
          </legend>
          <div v-show="extra_filters" class="row">
            <div class="col-md-4">
              <ncs-select field="ncs_documents.neologismo"/>
            </div>
            <div class="col-md-4">
              <ncs-select field="ncs_documents.etimologia"/>
            </div>
            <div class="col-md-4">
              <ncs-multi-select field="ncs_documents.profesion" operator="array_contains"/>
            </div>
            <div class="col-md-4">
              <ncs-multi-select field="ncs_documents.estilo" operator="array_contains"/>
            </div>
            <div class="col-md-4">
              <ncs-multi-select field="ncs_documents.politica_linguistica" operator="array_contains"/>
            </div>
            <div class="col-md-4">
              <ncs-multi-select field="ncs_documents.dimension_linguistica" operator="array_contains"/>
            </div>
            <div class="col-md-4">
              <ncs-multi-select field="ncs_documents.procedimientos" operator="array_contains"/>
            </div>
            <div class="col-md-4">
              <ncs-multi-select field="ncs_documents.prestamos" operator="array_contains"/>
            </div>
            <div class="col-md-4">
              <ncs-multi-select field="ncs_documents.formacion" operator="array_contains"/>
            </div>
            <div class="col-md-4">
              <ncs-multi-select field="ncs_documents.fraseologia" operator="array_contains"/>
            </div>
            <div class="col-md-4">
              <ncs-multi-select field="ncs_documents.estrategias" operator="array_contains"/>
            </div>
            <div class="col-md-4">
              <ncs-multi-select field="ncs_documents.tipos" operator="array_contains"/>
            </div>
          </div>
        </fieldset>
      </div>
      <ncs-element-section/>
      <div class="btn-group align-self-end mt-3">
        <ncs-select-download-button v-if="resultType === 'matching_expressions'"/>
        <ncs-page-download-button v-else/>
        <ncs-back-button/>
        <ncs-reset-button/>
        <ncs-search-button/>
      </div>
    </form>
    <ncs-result>
      <ncs-frequency-result/>
      <ncs-full-frequency-result/>
      <ncs-kwic-result/>
      <ncs-matching-expressions-result/>
      <ncs-context-result/>
      <documents-result/>
      <document-result/>
    </ncs-result>
  </div>
</template>
<script>
  import {mapState} from 'vuex'
  import Ncs from 'ncs'
  import DocumentsResult from './DocumentsResult'
  import DocumentResult from './DocumentResult'

  export default {
    extends: Ncs.defaultComponents.NcsForm,
    components: {DocumentsResult, DocumentResult},
    data() {
      return { extra_filters: false }
    },
    computed: mapState({
      resultType: s => s.api.resultType
    })
  }
</script>
<style lang="scss">
  @import "../scss/variables";

  legend {
    color: $primary;
    border-bottom: 1px solid $primary;
    font-size: 14px;
    margin-bottom: 5px;
  }

  label {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 0;
  }

  .form-group {
    margin-bottom: 0.25rem;
  }
</style>
